import './fresonbros/style';
import FormStructure from './fresonbros/form_structure';

export default FormStructure;